import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBars, 
  faTimes, 
  faUser, 
  faBell, 
  faSignOutAlt,
  faBriefcase,
  faCircle,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import '../Css/AdminNavbar.css';
import { API_URL } from '../utils/Function';
import LogoutModal from './LogoutModal';

export default function AdminNavbar({ isSidebarCollapsed, toggleSidebar, currentPage }) {
  const [user, setUser] = useState(null);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    fetchNotifications();
    
    // Poll for new notifications every 30 seconds
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  // Function to calculate relative time
  const getRelativeTime = (date) => {
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInSeconds < 60) return 'Just now';
  if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  if (diffInWeeks < 4) return `${diffInWeeks} week${diffInWeeks > 1 ? 's' : ''} ago`;
  if (diffInMonths < 12) return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`;
  return `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`;
};


  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Remove Authorization header for now since it's causing CORS issues
      const response = await fetch(`${API_URL}/career_application.php/get`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      if (data.success) {
        const pendingApps = data.applications || [];
       const notificationList = pendingApps.map(app => {
  // FIX THE TIMEZONE ISSUE HERE
  const fixedDate = new Date(app.applied_at.replace(" ", "T") + "+05:30");

  return {
    id: app.id,
    type: 'career_application',
    title: `New Job Application`,
    message: `${app.full_name} applied for ${app.career_title || 'a position'}`,
    
    // Use fixed date
    time: getRelativeTime(fixedDate),
    exactTime: fixedDate.toLocaleTimeString('en-IN'),
    exactDate: fixedDate.toLocaleDateString('en-IN'),
    appliedAt: fixedDate,
    
    isRead: localStorage.getItem(`notification_${app.id}_read`) === 'true',
    applicationId: app.id
  };
});

        
        setNotifications(notificationList);
        setUnreadCount(notificationList.filter(n => !n.isRead).length);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const markAsRead = (notificationId) => {
    const updatedNotifications = notifications.map(notification => 
      notification.id === notificationId 
        ? { ...notification, isRead: true }
        : notification
    );
    
    setNotifications(updatedNotifications);
    setUnreadCount(updatedNotifications.filter(n => !n.isRead).length);
    localStorage.setItem(`notification_${notificationId}_read`, 'true');
  };

  const markAllAsRead = () => {
    const updatedNotifications = notifications.map(notification => ({
      ...notification,
      isRead: true
    }));
    
    setNotifications(updatedNotifications);
    setUnreadCount(0);
    
    notifications.forEach(notification => {
      localStorage.setItem(`notification_${notification.id}_read`, 'true');
    });
  };

  const handleNotificationClick = (notification) => {
    markAsRead(notification.id);
    setShowNotifications(false);
  };

  const getRoleDisplayName = (role) => {
    switch (role) {
      case 'admin': return 'Administrator';
      case 'user': return 'User';
      case 'moderator': return 'Moderator';
      default: return role;
    }
  };

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'admin': return 'role-badge-admin';
      case 'user': return 'role-badge-user';
      case 'moderator': return 'role-badge-moderator';
      default: return 'role-badge-user';
    }
  };

  // Remove the old handleLogout function and replace with:
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    setShowUserMenu(false); // Close user menu when opening logout modal
  };

  const handleProfile = () => {
    window.location.href = '/admin/users';
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserMenu && !event.target.closest('.navbar-user-container')) {
        setShowUserMenu(false);
      }
      if (showNotifications && !event.target.closest('.notifications-container')) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu, showNotifications]);

  return (
    <div className={`admin-navbar ${isSidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}>
      <div className="navbar-left">
        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={isSidebarCollapsed ? faTimes : faBars} />
        </button>
        <h2 className="navbar-title">{currentPage}</h2>
      </div>

      <div className="navbar-right">
       

        {/* Notifications Dropdown */}
        <div className="notifications-container">
          <button 
            className="navbar-icon-btn" 
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FontAwesomeIcon icon={faBell} />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>

          {showNotifications && (
            <div className="notifications-dropdown">
              <div className="notifications-header">
                <h3>Notifications ({notifications.length})</h3>
                {unreadCount > 0 && (
                  <button className="mark-all-read" onClick={markAllAsRead}>
                    Mark all as read
                  </button>
                )}
              </div>
              
              <div className="notifications-list">
                {notifications.length > 0 ? (
                  notifications.map(notification => (
                    <div 
                      key={notification.id}
                      className={`notification-item ${!notification.isRead ? 'unread' : ''}`}
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className="notification-icon">
                        <FontAwesomeIcon icon={faBriefcase} />
                        {!notification.isRead && (
                          <FontAwesomeIcon icon={faCircle} className="unread-indicator" />
                        )}
                      </div>
                      <div className="notification-content">
                        <h4>{notification.title}</h4>
                        <p>{notification.message}</p>
                        <span className="notification-time" title={`${notification.exactDate} at ${notification.exactTime}`}>
                          <FontAwesomeIcon icon={faClock} className="time-icon" />
                          {notification.time}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-notifications">
                    <p>No new notifications</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* User Menu */}
        {user && (
          <div className="navbar-user-container">
            <div className="navbar-user" onClick={() => setShowUserMenu(!showUserMenu)}>
              <div className="user-info">
                <span className="user-name">{user.name}</span>
                <span className={`user-role ${getRoleBadgeClass(user.role)}`}>
                  {getRoleDisplayName(user.role)}
                </span>
              </div>
              <div className="user-avatar">
                {user.image_url ? (
                  <img src={`${API_URL}/${user.image_url}`} alt={user.name} />
                ) : (
                  <FontAwesomeIcon icon={faUser} />
                )}
              </div>
            </div>

            {showUserMenu && (
              <div className="user-dropdown">
                <button className="dropdown-item" onClick={handleProfile}>
                  <FontAwesomeIcon icon={faUser} />
                  <span>Profile</span>
                </button>
                <button className="dropdown-item logout-btn" onClick={handleLogoutClick}>
                  <FontAwesomeIcon icon={faSignOutAlt} />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Logout Modal */}
      <LogoutModal 
        isOpen={showLogoutModal} 
        onClose={() => setShowLogoutModal(false)} 
      />
    </div>
  );
}